import type { ToolbarOption } from './types';

export const defaultToolbar: ToolbarOption[] = [
  'heading',
  'fontColor',
  'bold',
  'italic',
  'underline',
  'strikethrough',
  'numberedList',
  'bulletedList',
  'outdent',
  'indent',
  'mediaEmbed',
  'imageUpload',
  'link',
  'wproofreader',
];

export const mobileViewport =
  'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0, shrink-to-fit=no';
